enum FixedTermMaturityType {
    ReinvestFullBalance = "REINVEST_FULL_BALANCE",
    FullWithdrawal = "FULL_WITHDRAWAL",
    InterestOnlyWithdrawal = "INTEREST_ONLY_WITHDRAWAL",
    Custom = "CUSTOM"
}
export default FixedTermMaturityType